import React from 'react';
import { connect } from 'react-redux';
import { setSearchForm, setErrorMessage } from '../../stories/actions';

import imageTimeExpire from "../../images/time_expire_white.png";

const TimeExpire = ({ setSearchFormAction, setErrorMessageAction }) => {
    const handlerIntialReturn = () => {
        setErrorMessageAction("");
        setSearchFormAction("login");
        window.location.href = window.location.origin;
    };

    return (
        <div className='row'>
            <div className='col-md-3'></div>

            <div className='col-md-12 form_container'>
                <div className='form_card'>
                    <img src={imageTimeExpire} alt="Image time expiere" className="image_time_expire" />

                    <div className="col-md-6 mb-2">
                        <div className='button_group_container' onClick={handlerIntialReturn}>
                            <span className="button_group_paragraph_style">Retornar ao início</span>
                            <span className="material-symbols-outlined button_group_icon_style"> arrow_back </span>
                        </div>
                    </div>
                </div>

                <div className='col-md-3'></div>
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setSearchFormAction: (searchForm) => dispatch(setSearchForm(searchForm)),
        setErrorMessageAction: (errorMessage) => dispatch(setErrorMessage(errorMessage))
    };
};

export default connect(mapStoreToProps, mapActionToProps)(TimeExpire);